import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { type SessionTopicStatsRecord } from "../SessionTopicRecord";

import { sessionQueryKeys } from "./sessionQueryKeys";

/** One topic's stats over a session's data, grouped by field. */
export function useSessionTopicStats(
  sessionId: string,
  topicId: string,
  { enabled = true }: { enabled?: boolean } = {},
): UseQueryResult<SessionTopicStatsRecord, Error> {
  const { sessionService } = useDomainServices();
  return useQuery<SessionTopicStatsRecord, Error>({
    queryKey: sessionQueryKeys.topicStats(sessionId, topicId),
    queryFn: ({ signal }) =>
      sessionService.getTopicStats(sessionId, topicId, { abortSignal: signal }),
    enabled,
  });
}
